import React from "react";

const Footer = () => {

    return (
        <div className="footer">©2022 Peek Robotics. All rights reserved.</div>
    );
};

export default Footer;